<script setup lang="ts">
import AppShell from "../Layout/AppShell.vue"
import CustomerForm from "./components/CustomerForm.vue"

defineProps<{
  customer: {
    id?: number | null
    company_id: number | ""
    name: string
    person_type: string
    document: string
    email: string
    phone: string
    addresses: Array<{
      id?: number | null
      label: string
      street: string
      number: string
      complement: string
      district: string
      city: string
      state: string
      zip_code: string
    }>
  }
  companies: Array<{ id: number; name: string }>
  errors?: Record<string, string[]>
}>()
</script>

<template>
  <AppShell>
    <CustomerForm
      mode="create"
      title="Novo cliente"
      subtitle="Cadastre cliente e mantenha um ou mais enderecos para faturamento e entrega."
      :customer="customer"
      :companies="companies"
      :errors="errors"
    />
  </AppShell>
</template>

